import { BuildAllModal, type BuildAllModalProps } from './BuildAllModal';
import type { PipelineNode } from '../services/pipelineNode.service';

// Re-export helpers so existing imports don't break
export { getNodeStatusDisplay, getNodeStatusVariant, getOrchestrationStatusVariant } from './BuildAllModal';

interface RebuildModalProps {
  node: PipelineNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  defaultForce?: boolean;
  defaultCheckForNewRecords?: boolean;
  autoStart?: boolean;
}

export function RebuildModal({ node, open, onOpenChange, defaultForce, defaultCheckForNewRecords, autoStart }: RebuildModalProps) {
  return (
    <BuildAllModal
      open={open}
      onOpenChange={onOpenChange}
      node={node}
      defaultForce={defaultForce}
      defaultCheckForNewRecords={defaultCheckForNewRecords}
      autoStart={autoStart}
    />
  );
}
